import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import smoothscroll from 'smoothscroll-polyfill';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useSelector } from 'react-redux';
import scrollbarVisible from '../functions/scrollbarVisible';

smoothscroll.polyfill();

const useStyles = makeStyles((theme) => ({
  root: () => ({
    padding: '0px 20px',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: 893,
    flexWrap: 'nowrap',
    flexDirection: 'column',
  }),
  providerRootQuestionContainer: {
    backgroundColor: '#fff',
    borderRadius: 5,
    padding: '0px 20px',
    marginLeft: 'auto',
    marginRight: 'auto',
    flexWrap: 'nowrap',
    flexDirection: 'column',
    height: 'calc(100% - 62px) !important',
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
    },
  },
}));

export const QuestionContainer = (props) => {
  const {
    className, children, questionId, embedded,
  } = props;
  const { appConfiguration: { providerSpecific } = {} } = useSelector((state) => state) ?? {};

  const classes = useStyles({ embedded });
  const ref = React.useRef();

  React.useEffect(() => {
    const isScrollbarVisible = scrollbarVisible(ref.current);

    if (!ref.current || !isScrollbarVisible) {
      return;
    }

    // Scroll to the top if scrollbar exists
    ref.current.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, [questionId]);

  const isProvider = !!providerSpecific?.code;

  // unmounting (children is not rendered) causes side effects in rendered question (e.g. children)
  return (
    <Grid
      container
      className={cx(
        className,
        { [classes.providerRootQuestionContainer]: isProvider, [classes.root]: !isProvider },
      )}
      ref={ref}
    >
      {children}
    </Grid>
  );
};

QuestionContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  questionId: PropTypes.string,
  embedded: PropTypes.bool,
};
